import Report from './Report';
// import {ReportTypes} from './types';

// export {ReportTypes};

export default Report;

